import { formValueSelector, change } from 'redux-form';
import { selectedInstrumentSelector } from '../selectors/instrumentPositionSelectors';
import { incrementUiValue } from '../../helpers/decimalPlaces/decimalPlacesHelper';
import get from 'lodash/get';

/**
 * Fields which *should* be incremented via Instrument.PriceIncrement
 *  + QuantityIncrement settings.
 */
var fieldMap = {
  limitPrice: true,
  stopPrice: true,
  quantity: true,
  trailingAmount: true,
  limitOffset: true
};
var validForms = {
  orderEntry: true,
  advancedOrderEntry: true,
  reportBlockTrade: true
};

/**
 * Snap form values to Instrument.PriceIncrement.
 */
var priceQuantityIncrementMiddleware = function priceQuantityIncrementMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === '@@redux-form/BLUR' && validForms[get(action, 'meta.form')] && fieldMap[get(action, 'meta.field')]) {
        var state = store.getState();
        var _selectedInstrumentSe = selectedInstrumentSelector(state),
          PriceIncrement = _selectedInstrumentSe.PriceIncrement,
          QuantityIncrement = _selectedInstrumentSe.QuantityIncrement;
        var Increment = action.meta.field === 'quantity' ? QuantityIncrement : PriceIncrement;
        var val = formValueSelector(action.meta.form)(state, action.meta.field);
        var incrementedVal = incrementUiValue(val, Increment);
        if (val !== incrementedVal) {
          store.dispatch(change(action.meta.form, action.meta.field, incrementedVal));
        }
      }
      return next(action);
    };
  };
};
export default priceQuantityIncrementMiddleware;